import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { Quiz } from '../interfaces/quiz.interface';
import { ILead } from '../interfaces/lead.interface';
import { LeadDto } from '../interfaces/lead-dto.interface';
import { HttpProvider } from './http.provider';
import { HttpMethod } from "../enums/http-method.enum";
import { appConfig } from "../config/app.config";

const httpProvider = new HttpProvider(appConfig());

const simpleBaseQuery = (): BaseQueryFn<
  { url: string, method?: HttpMethod, body?: any }, // Args
  any // Result
> => async (arg) => {
  const { url, method = HttpMethod.GET, body } = arg;
  const response = await httpProvider.fetch(url, { method, body });
  return { data: response };
}

export const quizAPI = createApi({
  reducerPath: 'quizAPI',
  baseQuery: simpleBaseQuery(),
  endpoints: build => ({
    getQuiz: build.query<Quiz, string>({
      query: (id) => ({
        url: `/quizzes/${id}?imageFormat=object`,
      })
    }),
    getQuizContent: build.query<Partial<Quiz>, string>({
      query: (id) => ({
        url: `/quiz-contents/${id}?imageFormat=object`,
      })
    }),
    createLead: build.mutation<ILead, LeadDto>({
      query: body => ({
        url: `/leads/`,
        method: HttpMethod.POST,
        body: body
      })
    }),
    updateLead: build.mutation<ILead, { id: string, body: Partial<LeadDto> }>({
      query: ({ id, body }) => ({
        url: `/leads/${id}`,
        method: HttpMethod.PATCH,
        body: body
      })
    }),
    hasResults: build.query<boolean, string>({
      query: id => ({
        url: `/leads/${id}/has-results`,
      })
    }),
    getUserInfo: build.query<Record<string, any>, string>({
      query: token => ({
        url: `https://login.yandex.ru/info?format=json&oauth_token=${token}`
      })
    })
  })
});

export const {
  useGetQuizQuery,
  useLazyGetQuizQuery,
  useGetQuizContentQuery,
  useLazyGetQuizContentQuery,
  useCreateLeadMutation,
  useUpdateLeadMutation,
  useHasResultsQuery,
  useLazyGetUserInfoQuery,
  useGetUserInfoQuery
} = quizAPI;